import React from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@mui/material';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';

const Title: React.FC = observer(() => (
  <div
    style={{
      position: 'absolute',
      width: 'calc(100% - 60px)',
      height: '100%',
      pointerEvents: 'none',
      top: 0,
      bottom: 0,
      left: 40,
      margin: 'auto 0',
      animation: 'fadeIn 300ms linear',
    }}
  >
    <style>
      {`
        @keyframes fadeIn {
          0% { color: #000; opacity: 0; }
          100% { opacity: 1; }
        }
      `}
    </style>
    <Grid container justifyContent="center" alignItems="center" sx={{ width: '100%', height: '100%', fontSize: '1.3rem' }}>
      <Grid sx={(theme) => ({
        overflow: 'hidden',
        textAlign: 'center',
        textOverflow: 'ellipsis',
        pl: theme.spacing(2),
      })}
      >
        {AppStore.app.name}
      </Grid>
    </Grid>
  </div>
));

export default Title;
